<mat-expansion-panel>
    <mat-expansion-panel-header>
      Filtra
    </mat-expansion-panel-header>
    <form [formGroup]="filtersForm" novalidate>
      <div class="u-flex-full">
        <mat-form-field class="u-full-width">
          <mat-label>Ricerca libera</mat-label>
          <input type="text" matInput formControlName="search">
        </mat-form-field>
      </div>
      <div class="u-flex-full" style="justify-content: flex-end;">
          <button mat-raised-button [disabled]="filtersForm.pristine"
            (click)="applyFilters()" color="primary">Filtra</button>
          <button mat-icon-button *ngIf="!filtersForm.pristine" (click)="resetFilters()" matTooltip="Reset">
            <mat-icon>replay</mat-icon>
          </button>
      </div>
    </form>
</mat-expansion-panel>